// src/services/api/orders.ts
// 
// ✨ ИЗМЕНЕНО: Удален отдельный метод updateInvoiceFlag
// Флаг invoice_sent_flag теперь передается через updateOrderStatus
//
import { apiClient, ApiResponse } from './index';

export interface Order {
  id: number;
  order_number: string;
  customer_name: string;
  customer_phone: string;
  payment_phone: string;
  customer_street: string;
  customer_house_number: string;
  total_price: number;
  total_items: number;
  delivery_fee: number;  // 0 если бесплатная, 1500 если платная
  
  // 🆕 НОВЫЕ ПОЛЯ ДЛЯ БОНУСОВ
  bonus_amount: number;
  bonus_payment_phone?: string;
  bonus_applied: boolean;
  bonus_summary?: string;
  
  // 🆕 НОВОЕ ПОЛЕ: Сумма к оплате
  amount_to_pay: number;
  amount_to_pay_display?: string;
  
  status: 'pending' | 'confirmed' | 'preparing' | 'delivering' | 'completed' | 'cancelled' | 'abandoned';
  payment_status: 'pending' | 'paid' | 'failed' | 'refunded';
  delivery_date: string;
  delivery_time_slot: string;
  created_at: string;
  updated_at: string;
  full_address: string;
  
  invoice_sent_flag: boolean;
}

export const ordersApi = {
  getOrders: (params?: {
    page?: number;
    per_page?: number;
    status?: string;
    payment_status?: string;
    date_from?: string;
    date_to?: string;
    search?: string;
    min_amount?: number;
    max_amount?: number;
  }) =>
    apiClient.get<ApiResponse<{
      count: number;
      total_pages: number;
      current_page: number;
      per_page: number;
      has_next: boolean;
      has_previous: boolean;
      results: Order[];
    }>>('/api/admin/orders/list/', { params }),

  getOrder: (orderId: number) =>
    apiClient.get<ApiResponse<{
      order: Order;
      additional_info: {
        days_since_created: number;
        payment_expired: boolean;
        order_items_count: number;
        formatted_address: string;
      };
    }>>(`/api/admin/orders/${orderId}/`),

  // ✨ ИЗМЕНЕНО: Добавлен параметр invoice_sent_flag (опциональный)
  updateOrderStatus: (orderId: number, data: { 
    status: string; 
    comment?: string; 
    payment_status?: string;
    invoice_sent_flag?: boolean;  // ✨ НОВЫЙ ПАРАМЕТР
  }) =>
    apiClient.post<ApiResponse<Order>>(`/api/admin/orders/${orderId}/status/`, data),

  bulkUpdateOrders: (data: { 
    order_ids: number[]; 
    status: string; 
    comment?: string; 
    payment_status?: string;
  }) =>
    apiClient.post<ApiResponse<{
      updated_count: number;
      payment_updated_count: number;
      new_status: string;
      new_payment_status?: string;
      order_ids: number[];
    }>>('/api/admin/orders/bulk-update/', data),

  getAnalytics: (params?: {
      date_from?: string;
      date_to?: string;
  }) =>
      apiClient.get<ApiResponse<{
        date_from: string;
        date_to: string;
      summary: {
        total_orders: number;
        completed_orders: number;
        total_revenue: number;
        average_order_value: number;
      };
      status_distribution: Array<{
        status: string;
        count: number;
        percentage: number;
      }>;
      top_customers: Array<{
        customer_name: string;
        customer_phone: string;
        orders_count: number;
        total_spent: number;
      }>;
    }>>('/api/admin/orders/analytics/', {
      params
    }),
};